/* /src/components/auth/silentRenew.jsx */

import React from "react";
import { AuthConsumer } from '../../contexts/authProvider';
import LoadingIndicator from '../wrapper/LoadingIndicator/LoadingIndicator';

export const SilentRenew = () => (
    <AuthConsumer>
        {({ signinSilentCallback }) => {
            signinSilentCallback();
            return <LoadingIndicator active={true} />;
        }}
    </AuthConsumer>
);